import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const requiredFirebaseConfigKeys = [
  ['REACT_APP_FIREBASE_API_KEY', firebaseConfig.apiKey],
  ['REACT_APP_FIREBASE_AUTH_DOMAIN', firebaseConfig.authDomain],
  ['REACT_APP_FIREBASE_PROJECT_ID', firebaseConfig.projectId],
  ['REACT_APP_FIREBASE_STORAGE_BUCKET', firebaseConfig.storageBucket],
  ['REACT_APP_FIREBASE_MESSAGING_SENDER_ID', firebaseConfig.messagingSenderId],
  ['REACT_APP_FIREBASE_APP_ID', firebaseConfig.appId]
];

const missingFirebaseConfigKeys = requiredFirebaseConfigKeys
  .filter(([, value]) => !String(value || '').trim())
  .map(([key]) => key);

export const isFirebaseConfigured = missingFirebaseConfigKeys.length === 0;
export const firebaseConfigError = isFirebaseConfigured
  ? ''
  : `Missing Firebase config: ${missingFirebaseConfigKeys.join(', ')}.`;

if (!isFirebaseConfigured) {
  console.error(firebaseConfigError);
}

const app = isFirebaseConfigured ? initializeApp(firebaseConfig) : null;
export const auth = app ? getAuth(app) : null;
export const googleProvider = app ? new GoogleAuthProvider() : null;
const isLocalhost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);
const shouldDisableAppVerificationForTesting =
  process.env.REACT_APP_FIREBASE_DISABLE_APP_VERIFICATION === 'true' && isLocalhost;
export const isFirebasePhoneAuthTestingMode = shouldDisableAppVerificationForTesting;

if (shouldDisableAppVerificationForTesting && auth?.settings) {
  auth.settings.appVerificationDisabledForTesting = true;
}

let activeGooglePopupPromise = null;

export const signInWithGooglePopup = async () => {
  if (!isFirebaseConfigured || !auth || !googleProvider) {
    throw new Error(firebaseConfigError || 'Firebase is not configured.');
  }

  if (activeGooglePopupPromise) {
    return activeGooglePopupPromise;
  }

  activeGooglePopupPromise = signInWithPopup(auth, googleProvider).finally(() => {
    activeGooglePopupPromise = null;
  });

  return activeGooglePopupPromise;
};
